import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TableViewTogglesViewType } from '@rio-cloud/rio-uikit/components/table/TableViewToggles';
import TableViewTogglesValues from '@rio-cloud/rio-uikit/TableViewToggles';
import moment from 'moment';

import { UiStatePart } from '../../setup/types';
import { DateRange } from '../../types';

export type UiState = {
    dateRange: DateRange;
    filteredSegment?: DateRange;
    columnToggleDialogVisible: boolean;
    isGraphCollapsed: boolean;
    tableViewType: TableViewTogglesViewType;
    isMobile: boolean;
};

const createDefaultDateRange = (): DateRange => ({
    start: moment().startOf('day').subtract(10, 'days').toDate(),
    end: moment().endOf('day').toDate(),
});

export const defaultState: UiState = {
    isGraphCollapsed: false,
    dateRange: createDefaultDateRange(),
    columnToggleDialogVisible: false,
    filteredSegment: undefined,
    tableViewType: TableViewTogglesValues.VIEW_TYPE_TABLE,
    isMobile: false,
};

const uiSlice = createSlice({
    name: 'ui',
    initialState: defaultState,
    reducers: {
        setFilteredSegment(state, { payload }: PayloadAction<DateRange | undefined>) {
            state.filteredSegment = payload;
        },
        setIsGraphCollapsed(state, { payload }: PayloadAction<boolean>) {
            state.isGraphCollapsed = payload;
        },
        setDateRange(state, { payload }: PayloadAction<DateRange>) {
            state.dateRange = payload;
            state.filteredSegment = undefined;
        },
        setTableViewType(state, { payload }: PayloadAction<TableViewTogglesViewType>) {
            state.tableViewType = payload;
        },
        setIsMobile(state) {
            state.tableViewType = TableViewTogglesValues.VIEW_TYPE_MULTI_CARDS;
            state.isMobile = true;
        },
    },
});

export const { setFilteredSegment, setDateRange, setIsGraphCollapsed, setTableViewType, setIsMobile } = uiSlice.actions;
export default uiSlice.reducer;

export const isGraphCollapsed = (state: UiStatePart): boolean => state.ui.isGraphCollapsed;
export const getTableViewType = (state: UiStatePart): TableViewTogglesViewType => state.ui.tableViewType;
export const isMobile = (state: UiStatePart): boolean => state.ui.isMobile;
